import { Alert } from './../../_models/alert';
import { UserService } from 'src/app/_services/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-forgotten-password-send-new-pass',
  templateUrl: './forgotten-password-send-new-pass.component.html',
  styleUrls: ['./forgotten-password-send-new-pass.component.css']
})
export class ForgottenPasswordSendNewPassComponent implements OnInit {
  tx:""
  ux:""
  loading=false
  isSuccess=true
  constructor(
    private activatedRoute:ActivatedRoute,
    private route:Router,
    private userService:UserService
  ) { }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(
      q=>{
        this.tx=q['tx']
        this.ux=q['ux']
        let msg=""
        this.userService.generatePasswordLink(this.postData()).subscribe(

          rsData=>{
            let status =+rsData['status']
            msg =rsData['message']
            this.loading=false
            if(status==1){
              this.isSuccess=true
            }else{
              this.isSuccess=false

            }
            Alert.alertMessage("Yes",msg)
            this.route.navigate(['/user/login/account/1/0']);
          },
          err=>{
            this.loading=false
            Alert.alertMessage("Oops",msg)
          }
        )
      }
    )
  }

  postData(){
    let body = new URLSearchParams();
    body.set('tx', this.tx);
    body.set('ux', this.ux);

    return body.toString()
  }
}
